class EmbellishmentProducts {
  constructor () {
    if (!this.embellishmentBoxId) return

    this.setupListeners()
  }

  setupListeners () {
    this.checkEmbellishedProducts = this.checkEmbellishedProducts.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.checkEmbellishedProducts,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_MULTIPLE_ADD,
      this.checkEmbellishedProducts,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.checkEmbellishedProducts,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
      this.checkEmbellishedProducts,
    )
  }

  async checkEmbellishedProducts () {
    this.cart = await window.BAO.utils.fetchJSON(`${window.routes.cart_url}`)

    const embellishmentBox = this.embellishmentBox
    const hasEmbellishmentProduct = this.hasEmbellishmentProducts

    if (hasEmbellishmentProduct && !embellishmentBox) {
      this.addEmbellishmentBox()
    } else if (!hasEmbellishmentProduct && embellishmentBox) {
      this.removeEmbellishmentBox()
    }
  }

  addEmbellishmentBox () {
    window.BAO.Cart.addItem(
      {
        id: this.embellishmentBoxId,
        quantity: 1,
        properties: {
          _embellishment_box: true,
        },
      },
      null,
      {
        sections: window.BAO.utils.sectionRenderer.pushCartSections.map(
          s => s.section,
        ),
      },
    )
  }

  async removeEmbellishmentBox () {
    if (!this.isCartPage) {
      window.BAO.Cart.removeItem(this.embellishmentBox.key)
      return
    }

    this.embellishmentBoxCartItemEl?.remove()

    const cartState = await window.BAO.Cart.removeItem(
      this.embellishmentBox.key,
      window.BAO.utils.sectionRenderer.cartSections.map(s => s.section),
    )

    await this.render(cartState)
  }

  async render (state) {
    if (state.item_count === 0) return window.location.reload()

    if ('sections' in state) this.renderSections(state.sections)
  }

  renderSections (stateSections) {
    const sections = window.BAO.utils.sectionRenderer.cartSections

    if (stateSections.length === 0) return

    const sectionsToRender = sections
      .filter(s => s.id in stateSections)
      .map(s => Object.assign({}, s, { html: stateSections[s.id] }))

    window.BAO.utils.sectionRenderer.renderMultiple(sectionsToRender)

    if (!window.loyaltylion) return

    window.loyaltylion.ui.refresh()
  }

  get embellishmentBoxCartItemEl () {
    return document.querySelector('cart-item[data-embellishment-box]')
  }

  get hasEmbellishmentProducts () {
    return !!this.cart.items.filter(
      lineItem =>
        lineItem.properties && !!lineItem.properties._embellished_product,
    ).length
  }

  get embellishmentBox () {
    return this.cart.items.find(
      lineItem => lineItem.variant_id === this.embellishmentBoxId,
    )
  }

  get embellishmentBoxId () {
    const id = this.isCartPage
      ? this.cartEl?.dataset?.embellishmentBox
      : this.pushCartEl?.dataset?.embellishmentBox

    return id && parseInt(id)
  }

  get isCartPage () {
    return !!this.cartEl
  }

  get cartEl () {
    return document.querySelector('.crt-Cart')
  }

  get pushCartEl () {
    return document.querySelector('.psh-Cart')
  }
}

window.BAO.EmbellishmentProducts = EmbellishmentProducts
